import { GATES } from '../constants/auth';
import { useGetIsUngated } from './useGetIsUngated';
export const useHasQuotesTeamBeta = () => {
  const getIsUngated = useGetIsUngated();
  return getIsUngated(GATES.QUOTES_TEAM_BETA);
};